import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { ScrollService } from '../api/';
import { SurveyService } from '../survey.service';
const Swal = require('sweetalert2');


@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  currentDate: any = '';
  currentYear: any = '';
  userid:any;
  
  constructor(private scrollService: ScrollService,private router:Router,private Surveyservice:SurveyService) { }

  ngOnInit() {
    this.currentDate = new Date();
    this.currentYear = this.currentDate.getFullYear();
    this.scrollService.enableScrollIfDisabled();
    this.userid = localStorage.getItem("user_id");
    if(this.userid)
    {

          this.Surveyservice.NewSurvey().subscribe((response => {
            let data:any = response; //response.json();
            if(data.status === true)
            {

              let id = data.latest_survey.SurveyID;
              this.Surveyservice.CheckSurvey(id,this.userid).subscribe(response => {
                let obj = response; //response.json();
                console.log(obj);
                if(obj.status == false)
                {
                  Swal.fire({
                    title: '  New Survey has been uploaded',
                    text:'Click on the button to fill survey',
                    confirmButtonText: `Open Survey`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      this.router.navigate(['survey',id]);
                    }
                  })
                }
              });
            }
        }));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts